import styled from "styled-components";

export const StepsParent=styled.div`

`